import React from 'react';

export default () => (
	<a href="tel:6467724205">Telephone number:<br/>6467724205</a>
);
